// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"d85e5156","4177":"d85e5156","4730":"c7c3b150","9591":"d063ca08"}[chunkId] + ".chunk.css";
};